// extracted by mini-css-extract-plugin
module.exports = {"recommendations":"individualCategoryRecommendations_recommendations__dpX5A"};